const faqItems = [
  {
    q: '糖心视频需要注册会员才能观看吗？',
    a: '完全不需要。糖心视频所有影视资源均可免费在线观看，无需注册、无需登录、无需付费。打开网站即可畅享高清电影、电视剧、综艺、动漫等海量内容，真正做到零门槛观影。',
  },
  {
    q: '观看视频会卡顿吗？支持高清播放吗？',
    a: '不会卡顿。糖心视频采用智能CDN加速和多线路自动切换技术，确保视频秒加载、播放流畅。支持1080P和4K超高清画质，同时自适应网络状况调整清晰度，在线不缓冲，观影体验媲美付费平台。',
  },
  {
    q: '手机和平板可以观看吗？需要下载APP吗？',
    a: '可以，而且不需要下载任何APP。糖心视频网站已适配手机、平板、电脑等全终端设备，直接通过浏览器访问即可观看。随时随地打开网页就能追剧，西瓜视频免费和91在线视频资源都能在移动端畅享。',
  },
  {
    q: '片库多久更新一次？能找到最新的影视剧吗？',
    a: '片库每日实时更新，热门影视剧上线后24小时内即可在糖心视频找到。我们持续追踪西瓜视频免费、免费视频网站91、91在线视频等平台的资源动态，确保您能第一时间看到最新内容。',
  },
  {
    q: '糖心视频有广告吗？安全吗？',
    a: '糖心视频以免费高清影视为核心，页面干净简洁。我们严格审核所有收录内容，确保不包含恶意弹窗、病毒或诱导下载。观影过程安全可靠，请放心使用。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="relative py-16 md:py-24 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/70 text-accent-700 text-xs font-semibold mb-4">
            解答疑惑
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            关于糖心视频的常见疑问，这里都有答案
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.q}
              className="bg-background-50 rounded-xl p-5 md:p-6 cursor-default"
            >
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2 flex items-start gap-3">
                <span className="text-primary-500 shrink-0 mt-0.5">
                  <i className="ri-question-line"></i>
                </span>
                {item.q}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed pl-7">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}